import React, { useEffect, useState } from 'react';
import { ncService } from '../../services/api';

/**
 * #243 — Relógio de SLA 8D (contenção 24h / resolução 10 dias úteis).
 *
 * Busca GET /api/v2/nc/{id}/sla. Se o cliente não tem sla_8d_habilitado, o
 * backend devolve sla=null → o componente NÃO renderiza nada (feature off).
 * Falha de rede também não renderiza (não quebra a tela da NC).
 */

function fmtRestante(horas, vencido) {
  if (vencido) return 'vencido';
  if (horas == null) return '';
  if (horas < 48) return `${Math.max(0, Math.round(horas))}h restantes`;
  return `${Math.max(0, Math.round(horas / 24))} dias restantes`;
}

function corBloco(bloco) {
  if (bloco.vencido) return '#b91c1c';
  if (bloco.horas_restantes != null && bloco.horas_restantes < 24) return '#b45309';
  return '#0d7c3f';
}

function Bloco({ rotulo, bloco }) {
  if (!bloco) return null;
  const cor = corBloco(bloco);
  let prazoStr = '';
  try {
    prazoStr = bloco.prazo ? new Date(bloco.prazo).toLocaleDateString('pt-BR') : '';
  } catch { /* ignora data inválida */ }
  return (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', fontSize: '13px' }}>
      <span style={{ color: '#64748b' }}>{rotulo}:</span>
      <strong style={{ color: cor }}>{fmtRestante(bloco.horas_restantes, bloco.vencido)}</strong>
      {prazoStr && <span style={{ color: '#94a3b8' }}>· prazo {prazoStr}</span>}
    </div>
  );
}

function SlaClock({ ncId }) {
  const [sla, setSla] = useState(null);

  useEffect(() => {
    let alive = true;
    if (!ncId) return undefined;
    ncService.getSla(ncId)
      .then((r) => { if (alive) setSla(r?.sla || null); })
      .catch(() => { /* feature off ou erro → não mostra */ });
    return () => { alive = false; };
  }, [ncId]);

  if (!sla || !sla.habilitado) return null;

  return (
    <div
      style={{
        display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '16px',
        margin: '8px 0 16px', padding: '10px 14px',
        background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px',
      }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontWeight: 600, color: '#334155', fontSize: '13px' }}>
        <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>timer</span>
        SLA 8D
      </span>
      <Bloco rotulo="Contenção (24h)" bloco={sla.contencao} />
      <Bloco rotulo="Resolução (10 dias úteis)" bloco={sla.resolucao} />
      {sla.encerrada && (
        <span style={{ color: '#64748b', fontSize: '12px', fontStyle: 'italic' }}>NC encerrada</span>
      )}
    </div>
  );
}

export default SlaClock;
